import React, { useState, useEffect} from 'react';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import { fetchContactInfo } from '../functions/fetchContactInfo';
import { SOURCE_URL } from '../../config';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import RenderSnA from '../functions/renderSnA';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../utils/FadeInEffect';

const ContactUs: React.FC = () => {
  const { ref, inView } = useInView({
      threshold: 0.1,
      triggerOnce: true,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [content, setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchContactInfo(language);
        if(data){
          setContent(data.attributes);
          setSeo(data?.attributes?.ContactUsSEO || null);
          setGa(data?.attributes?.ContactUsGA || null);
        }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  const customUrlTransform = (url: string) => {
    if (url.startsWith('tel:')) {
      return url;
    }
    return defaultUrlTransform(url);
  };

  const handleContactUs = (items: any) => {
    return Array.isArray(items) && items.map((item, index) => (
        <div key={index} >
            <h2 className={`mt-5 pt-3 mb-4 pb-2 text-center ${animationClass(inView, 'up')}`} style={animationStyle(inView,'up',language == "en" ? {fontFamily: "Montserrat"} : {fontFamily: "Noto Sans TC"})}>{item?.MainContactTitle}</h2>
            <div className={`light-gray-bg pb-5 contact-numbers ${animationClass(inView, 'up')}`} style={animationStyle(inView,'up')}>
                <div className="static-pages container-fluid" style={{maxWidth:"1340px"}}>
                    <div className="row justify-content-xl-between justify-content-start">
                        {handleContactUsContent(item?.Columns)}
                    </div>
                </div>
            </div>
        </div>
    ))
  }

  const handleContactUsContent = (items: any) => {
    return Array.isArray(items) && items.map((item, index) => (
        <div className="col-xl-auto col-lg-4 col-sm-6 contact-details mb-5" style={language == "en" ? {fontFamily: "Barlow"} : {fontFamily: "Noto Sans TC"}} key={index}>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} urlTransform={customUrlTransform}>{item?.ContactDetails}</ReactMarkdown>
        </div>
    ))
  }

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }
  
  const bannerImage = content?.ContactUsBanner?.BannerImage?.data?.attributes?.url;
  const bannerImageTab = content?.ContactUsBanner?.BannerImageTab?.data?.attributes?.url ?? bannerImage;
  const bannerImageMob = content?.ContactUsBanner?.BannerImageMob?.data?.attributes?.url ?? bannerImageTab;

  const bannerImagePosition = content?.ContactUsBanner?.BannerImagePosition?.toLowerCase();
  const bannerImagePositionTab = content?.ContactUsBanner?.BannerImagePositionTab?.toLowerCase() ?? bannerImagePosition;
  const bannerImagePositionMob = content?.ContactUsBanner?.BannerImagePositionMob?.toLowerCase() ?? bannerImagePositionTab;

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="inner-banner" className="object-item contact-us-1" data-imgposition={bannerImagePosition} data-imgpositiontab={bannerImagePositionTab} data-imgpositionmob={bannerImagePositionMob} >
        <img style={{objectPosition: bannerImagePosition}} className="object-desktop-image w-100 img-fit d-xl-block d-none lazyloaded" src={SOURCE_URL + bannerImage}/>
        <img style={{objectPosition: bannerImagePositionTab}} className="object-tab-image w-100 img-fit d-xl-none d-lg-block d-none lazyload" src={SOURCE_URL + bannerImageTab}/>
        <img style={{objectPosition: bannerImagePositionMob}} className="object-mobile-image w-100 img-fit d-lg-none d-block lazyloaded" src={SOURCE_URL + bannerImageMob}/>
        <div className={"pxc banner-text " + content?.ContactUsBanner?.BannerTextColor?.toLowerCase() + "-color animated"} style={language == "en" ? {fontFamily: "Barlow"} : {fontFamily: "Noto Sans TC"}}>
            <div ref={ref} className={animationClass(inView, 'up')} style={animationStyle(inView,'up')}>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.ContactUsBanner?.BannerText}</ReactMarkdown>
            </div> 
        </div>
    </section>

    <section id="main-content" className='contact-us'>
        {handleContactUs(content?.SetOfContacts)}
    </section>
    </>
  );
};

export default ContactUs;